<template>
    <v-data-table
      mobile-breakpoint="300"
      :options.sync="options"
      :disable-filtering="true"
      :disable-sort="true"
      v-on:update:page="changePage"
      v-on:update:sort-by="changeOrder"
      v-on:update:sort-desc="changeOrder"
      v-on:update:items-per-page="changeItemsPerPage"
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :hide-default-footer="hidePaginator()"
      :loading="loading"
      class="listing-app"
      item-key="id"
      :show-expand="false"
      :expanded.sync="expanded"
      :footer-props="{
        'items-per-page-options': options.itemsPerPageOptions,
        'items-per-page-text': $t('records_per_page'),
      }"
    >
      <template v-slot:item._actions="{ item }">
        <div class="d-flex justify-center">
          <v-btn
            :id="'btn-invoice-finalized-get-' + item.id"
            icon
            small
            tile
            plain
            :color="'warning'"
            :title="$t('list.Ver')"
            @click="executeGet(item)"
          >
            <v-icon small>mdi-magnify</v-icon>
          </v-btn>
        </div>
      </template>
   <!-- eslint-disable-next-line -->
   <template  v-slot:header.subsidiary><span class="body-2 font-weight-bold" id="header-item-stock-subsidiary"> {{$t('subsidiary')}}  </span> </template>
          <!-- eslint-disable-next-line -->
          <template  v-slot:header.warehouse><span class="body-2 font-weight-bold" id="header-item-stock-warehouse"> {{$t('warehouse')}}  </span> </template>
          <!-- eslint-disable-next-line -->
          <template  v-slot:header.product><span class="body-2 font-weight-bold" id="header-item-stock-product"> {{$t('product')}}  </span> </template>
          <!-- eslint-disable-next-line -->
          <template  v-slot:header.product_variant><span class="body-2 font-weight-bold" id="header-item-stock-product_variant"> {{$t('product_variant')}}  </span> </template>
          <!-- eslint-disable-next-line -->
          <template  v-slot:header.quantity><div class="body-2 text-center font-weight-bold" id="header-item-stock-quantity"> {{$t('quantity')}}  </div> </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.subsidiary="{ item }">
            <div class="field-stock-subsidiary" :class="'stock-subsidiary-'+item.id">{{ $filters.name(item.subsidiary) }}</div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.warehouse="{ item }">
            <div class="field-stock-warehouse" :class="'stock-warehouse-'+item.id"> Suc: {{ $filters.name(item.subsidiary) }} - {{ $filters.name(item.warehouse) }}</div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.product="{ item }">
            <div class="field-stock-product" :class="'stock-product-'+item.id">{{ $filters.name(item.product) }}</div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.product_variant="{ item }">
            <div class="field-stock-product_variant" :class="'stock-product_variant-'+item.id">{{ $filters.name(item.product_variant) }}</div>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.quantity="{ item }">
            <div class="field-stock-quantity text-center" :class="'stock-quantity-'+item.id">{{ item.quantity }}</div>
          </template>
    </v-data-table>
  </template>
  
<script>
import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
//import * as templateDesktop from "./InvoiceListFinalizedDesktop.vue?vue&type=template";
//import * as templateMobile from "./InvoiceListFinalizedMobile.vue?vue&type=template";
/*let render = templateDesktop.render;
if (window.innerWidth < 960) {
  render = templateMobile.render;
}*/

export default {
  mixins: [NextMixinListPage, MixinActions],
  props: ["product_id"],
  //render: render,
  data() {
    return {
      title: "Facturas",
      form: {},

      url: "api/v1/stock",

      pathBase: "/billing/invoice",
      pathCreate: "/billing/invoice/create",
      options: {
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        sortBy: ['invoice_date'],
        sortDesc: [true]
      },
      
      headers: [
        { title: "num", value: "index", sortable: false },
        { title: "warehouse", value: "warehouse", sortable: false },
        { title: "product_variant", value: "product_variant", sortable: false },
        { title: "quantity", value: "quantity", sortable: false },
        //{ title: "_actions", value: "_actions", sortable: false }
      ],
          };
  },
  methods: {
    breadcrumbsInit() {
        this.breadcrumbs = [
        ];
    },
    executeGet(item) {
      //window.open(this.pathBase + "/" + item.id, "_blank");
    },
    querySelections(params, paginate, order) {
      return new Promise((resolve, reject) => {
        //params['product'] = [ {id: this.product_id }];
        /*this.$store.dispatch("addFilter", {
          path: this.title,
          values: {
            url: this.$route.fullPath,
            params,
            _paginate: paginate,
            _order: order,
          },
        });*/
        //https://api.nubempresa.com/api/v1/stock?params={%22product%22:[{%22id%22:%22f9dd76bc-58ef-459e-820b-ce615a656b3a%22}],%22_paginate%22:{%22page%22:1,%22max_rows%22:10},%22_order%22:[{%22field%22:%22invoice_date%22,%22direction%22:%22DESC%22}]}
        //https://api.nubempresa.com/api/v1/stock?params={%22product%22:[{%22id%22:%22f9dd76bc-58ef-459e-820b-ce615a656b3a%22}],%22_paginate%22:{%22page%22:1,%22max_rows%22:10},%22_order%22:[{%22field%22:%22created_at%22,%22direction%22:%22ASC%22}]}

        const paramsDefault = this.getParamsDefault(params);
        this.$http
          .get(
            this.url,
            {
              //...params,
              product: [ {id: this.product_id }],
              ...paramsDefault,
              _paginate: paginate,
              _order: [{ field: 'created_at', direction: 'DESC'}],
            },
            true,
            true
          )
          .then((res) => {
            let { total, items, module_actions } = res;
            total = parseInt(total);
            resolve({ items, total, module_actions });
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => (this.loading = false));
      });
    },
  },
};
</script>
